import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ShareIcon from '@mui/icons-material/Share';
import { styled, useTheme } from '@mui/material';
import { IconComponents } from '../../assets/icons/icons';


type Props = {
    IconData?: React.ReactNode;
    onLineClick?: React.MouseEventHandler<HTMLDivElement>;
    onXClick?: React.MouseEventHandler<HTMLDivElement>;
    onFacebookClick?: React.MouseEventHandler<HTMLDivElement>;
    allow_light?: boolean;
};

const CustomSpeedDial = styled(SpeedDial)(({ }) => ({
    '& .MuiFab-primary': {
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
}))

export default function SpeedDialCustom({ onLineClick, onFacebookClick, onXClick, allow_light }: Props) {
    const actions = [
        { icon: <IconComponents.FacebookColorIcon />, name: 'Facebook', onClick: onFacebookClick },
        { icon: <IconComponents.XColorIcon />, name: 'X', onClick: onXClick },
        { icon: <IconComponents.LineColorIcon />, name: 'Line', onClick: onLineClick },
    ];
    const theme = useTheme();
    const mode = theme.palette.mode;

    return (
        <Box sx={{ width: 30, height: 30, position: 'relative', overflow: "visible" }}>
            <CustomSpeedDial
                ariaLabel="SpeedDial"
                direction="up"
                FabProps={{
                    size: 'small', // 👈 ทำให้ขนาดเท่าปุ่มอื่น
                    sx: {
                        height: 30,
                        width: 30,
                        '& .MuiFab-primary': {
                            bgcolor: 'green',           // your desired background color
                            '&:hover': {
                                bgcolor: 'darkgreen',     // hover color
                            },
                        },
                        color: mode === 'dark' ? 'white' : 'black',
                        bgcolor: (theme) => mode === 'dark' ? 'black' : "#fff", // ✅ กำหนดพื้นหลังเอง
                        minHeight: 'unset',
                        boxShadow: 'none', // ลบเงาให้ดูเรียบ
                        m: 0, // remove extra margin
                    },
                }
                }
                sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '50%',
                    height: 30,
                    width: 30,
                    zIndex: 90,
                    minHeight: 'unset',
                    transform: 'translate(-50%, -50%)',
                    p: 0,
                    overflow: 'visible', // ⭐️ สำคัญมาก ให้ SpeedDial ขยายออกนอกขอบ
                }}
                icon={<SpeedDialIcon icon={<ShareIcon sx={{ color: allow_light ? 'white' : 'auto' }} />} openIcon={<ShareIcon sx={{
                    color: allow_light ? 'white' : 'auto'
                }} />} />}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        PopperProps={{
                            sx: {
                                zIndex: 9999
                            }
                        }}

                        FabProps={{
                            size: 'small',
                            sx: {
                                // position:'absolute',
                            }
                        }}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={(e) => {
                            e.stopPropagation();
                            action?.onClick?.(e);
                        }}

                    />
                ))}
            </CustomSpeedDial>
        </Box>
    );
}
